import { Directive, HostListener, Input, Output, EventEmitter } from '@angular/core';
import subDays from 'date-fns/sub_days';
import subWeeks from 'date-fns/sub_weeks';
import subMonths from 'date-fns/sub_months';

/**
 * Change the view date to the previous view. For example:
 *
 * ```typescript
 * &lt;button
 *  mwlCalendarPreviousView
 *  [(viewDate)]="viewDate"
 *  [view]="view"&gt;
 *  Previous
 * &lt;/button&gt;
 * ```
 */

export class CalendarPreviousViewDirective {

  /**
   * The current view
   */
   view: string;

  /**
   * The current view date
   */
   viewDate: Date;

  /**
   * Called when the view date is changed
   */
   viewDateChange: EventEmitter<Date> = new EventEmitter();

  /**
   * @hidden
   */
  
  onClick(): void {

    const subFn: any = {
      day: subDays,
      week: subWeeks,
      month: subMonths
    }[this.view];

    this.viewDateChange.emit(subFn(this.viewDate, 1));

  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mwlCalendarPreviousView]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'view': [{ type: Input },],
'viewDate': [{ type: Input },],
'viewDateChange': [{ type: Output },],
'onClick': [{ type: HostListener, args: ['click', ] },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
